import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import { FoodMenu } from '../component/FoodMenu';
import { Sidebar } from '../component/Sidebar';
import { OrderPage } from './OrderPage';
import { OrderDetail } from './OrderDetail';

export const OrganizationPos = () => {
  const [selectedMenu, setSelectedMenu] = useState('food'); 
  const [orderId, setOrderId] = useState(null); 

  const handleOrderClick = (id) => {
    setOrderId(id);
    setSelectedMenu('order-detail');
  };

  const renderComponent = () => {
    switch (selectedMenu) {
      case 'order':
        return <OrderPage onOrderSelect={handleOrderClick} />;
      case 'order-detail':
        return <OrderDetail orderId={orderId} />;
      case 'food':
      default:
        return <FoodMenu />;
    }
  };

  return (
    <div className="page-content">
      <Row className="mb-3">
        <Col md={2}>
          <Sidebar setSelectedMenu={setSelectedMenu} />
        </Col>
        <Col className='p-0 m-0' md={10}>
          {renderComponent()}
        </Col>
      </Row>
    </div>
  );
};
